import * as React from 'react'

import type { Brief } from '@disco/types/types/brief'

import { ContextMenuTarget } from 'components/ds'

import { useExplorerContextMenusEnabled } from 'hooks/use-explorer-context-menus-enabled'

import BriefMenuBody from '../brief-action-menu/brief-menu-body'
import { useBriefMenu } from '../brief-action-menu/use-brief-menu'

type Props = {
  children: React.ReactNode
  brief: Brief | null | undefined
}

/**
 * Opens the brief's three-dot menu on right-click anywhere in `children`.
 *
 * The menu acts on this brief alone, matching the three-dot button, so a
 * right-click deliberately leaves the current multi-selection untouched.
 */
const BriefContextMenu = ({ children, brief }: Props): React.ReactNode => {
  const contextMenusEnabled = useExplorerContextMenusEnabled()

  // Skip useBriefMenu's selectors/state entirely while the flag is off,
  // rather than calling it on every row and disabling ContextMenuTarget after.
  if (!contextMenusEnabled || !brief) return children

  return (
    <BriefContextMenuContent brief={brief}>{children}</BriefContextMenuContent>
  )
}

const BriefContextMenuContent = ({
  children,
  brief,
}: {
  children: React.ReactNode
  brief: Brief
}): React.ReactNode => {
  const { deadlinePickerModal, handleOpenChange, ...menuProps } = useBriefMenu({
    brief,
  })

  return (
    <>
      <ContextMenuTarget
        onOpenChange={handleOpenChange}
        menu={<BriefMenuBody brief={brief} {...menuProps} />}
      >
        {children}
      </ContextMenuTarget>
      {deadlinePickerModal}
    </>
  )
}

export default BriefContextMenu
